import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import {
  FaLeaf,
  FaBolt,
  FaHeartbeat,
  FaSmile,
  FaUtensils,
  FaUsers,
  FaBook,
  FaSpa,
} from "react-icons/fa";
import Sok from "../../images/fruct.png";
import "./course.scss";

const benefits = [
  { id: 1,  icon: FaLeaf,     title: "Постройнеть от 3–5 кг за неделю",    color: "#22c55e", delay: 0.1 },
  { id: 2,  icon: FaSmile,    title: "Чистая сияющая кожа",                color: "#f59e0b", delay: 0.2 },
  { id: 3,  icon: FaUtensils, title: "Избавиться от тяги к вредной еде",   color: "#ef4444", delay: 0.3 },
  { id: 4,  icon: FaUsers,    title: "Найти друзей-единомышленников",     color: "#8b5cf6", delay: 0.4 },
  { id: 5,  icon: FaHeartbeat,title: "Улучшить здоровье",                  color: "#f97316", delay: 0.5 },
  { id: 6,  icon: FaBolt,     title: "Заряд энергии на целый день",        color: "#eab308", delay: 0.6 },
  { id: 7,  icon: FaBook,     title: "Знания о правильном питании",        color: "#06b6d4", delay: 0.7 },
  { id: 8,  icon: FaSpa,      title: "Баланс ума и тела",                  color: "#84cc16", delay: 0.8 },
];

const Course = () => {
  const sectionRef = useRef(null);
  const circleRef  = useRef(null);
  const isInView   = useInView(sectionRef, { once: true, margin: "-100px 0px" });

  const [radius, setRadius] = useState(280);
  useLayoutEffect(() => {
    const updateRadius = () => {
      if (!circleRef.current) return;
      const size = Math.min(circleRef.current.offsetWidth, circleRef.current.offsetHeight);
      const r = Math.max(120, Math.min(size * 0.36, 320));
      setRadius(r);
    };
    updateRadius();
    window.addEventListener("resize", updateRadius);
    return () => window.removeEventListener("resize", updateRadius);
  }, []);

  return (
    <motion.section
      id="about"
      className="course"
      ref={sectionRef}
      initial={{ opacity: 0 }}
      animate={isInView ? { opacity: 1 } : { opacity: 0 }}
      transition={{ duration: 0.8 }}
    >
      <div className="course-container">
        {/* Header */}
        <motion.div
          className="course-header"
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <motion.h1
            initial={{ opacity: 0, scale: 0.9 }}
            animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            Этот курс для тех, кто хочет:
          </motion.h1>

          <motion.div
            className="course-description"
            initial={{ opacity: 0 }}
            animate={isInView ? { opacity: 1 } : { opacity: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <p>Мы не только доставим вам вкусные свежевыжатые соки, которые помогут приблизиться к здоровью и телу мечты.</p>
          
            <p>Более 3000 человек уже проходят курс вместе с вами — общайтесь и делитесь своими результатами.</p>
          </motion.div>
        </motion.div>


        <div className="benefits-circle-container" ref={circleRef}>
          <motion.div
            className="center-fruit"
            initial={{ opacity: 0, scale: 0.5 }}
            animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.5 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            whileHover={{ scale: 1.08, rotate: 5 }}
          >
            <motion.div
              className="fruit-glow"
              animate={{ scale: [1, 1.2, 1], opacity: [0.3, 0.6, 0.3] }}
              transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
            />
            <motion.img
              src={Sok}
              alt="Ассорти свежих фруктов"
              animate={{ y: [0, -10, 0], rotate: [0, 3, -3, 0] }}
              transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
            />
          </motion.div>
          <div className="benefits-circle" aria-label="Преимущества курса">
            {benefits.map((b, index) => {
              const angle = (index * 360) / benefits.length;
              const rad = (angle * Math.PI) / 180;
              const x = Math.cos(rad) * radius;
              const y = Math.sin(rad) * radius;
              const Icon = b.icon;

              return (
                <div className="benefit-item" key={b.id}>
                  <motion.div
                    className="benefit-card"
                    style={{ "--benefit-color": b.color, x, y }}
                    initial={{ opacity: 0, scale: 0.0 }}
                    animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0 }}
                    transition={{ duration: 0.6, delay: 1.0 + index * 0.12, ease: "easeOut" }}
                    whileHover={{ scale: 1.08, zIndex: 10, transition: { duration: 0.15 } }}
                    whileTap={{ scale: 0.96 }}
                  >
                    <motion.div
                      className="benefit-icon"
                      whileHover={{ rotate: 360, scale: 1.15 }}
                      transition={{ duration: 0.5 }}
                      aria-hidden="true"
                    >
                      <Icon />
                    </motion.div>
                    <motion.h3
                      initial={{ opacity: 0, y: 10 }}
                      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 10 }}
                      transition={{ delay: 1.4 + index * 0.12 }}
                    >
                      {b.title}
                    </motion.h3>
                  </motion.div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Course;
